import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class ManifestSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'manifest-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
    getMinimumCspVersion() {
        return 3;
    }
}
